// @flow
import React, { type Node } from 'react';

import { places } from './places';


type Props = {
  placeId: string,
  width?: number,
  height?: number,
  className?: string,
  children?: Node,
}

const BannerPlaceHolder = ({
  placeId,
  width: widthReplace,
  height: heightReplace,
  className,
  children,
}: Props) => {
  const { width = 0, height = 0 } = places[placeId] || {};

  const style = {
    width: widthReplace || widthReplace === 0 ? widthReplace : width,
    height: heightReplace || heightReplace === 0 ? heightReplace : height,
  };

  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};

export default BannerPlaceHolder;
